import { render, staticRenderFns } from "./CommunityCommentTree.vue?vue&type=template&id=31027ba0&scoped=true&"
import script from "./CommunityCommentTree.vue?vue&type=script&lang=js&"
export * from "./CommunityCommentTree.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCommentTree.vue?vue&type=style&index=0&id=31027ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31027ba0",
  null
  
)

export default component.exports